/**
 * Website-level "Global Styles" CSS.
 *
 * This CSS is shared across every audience of a website. It is NOT part of the
 * per-audience GrapesJS style sheet (so it never gets baked into an audience's
 * saved `css`), it is injected directly into the canvas iframe for a live
 * preview and injected server-side at publish time (see server/blobStorage.js).
 *
 * The style element is appended after GrapesJS' own managed style tag so that
 * deliberately-authored global overrides win on equal specificity, matching the
 * ordering used on the published page.
 */

const CANVAS_STYLE_ID = 'global-styles-preview';

function upsertStyleEl(doc, id, css) {
  if (!doc) return;
  let el = doc.getElementById(id);
  if (!el) {
    el = doc.createElement('style');
    el.id = id;
    (doc.head || doc.documentElement || doc.body)?.appendChild(el);
  }
  // Keep the element last in <head> so it applies after GrapesJS' styles.
  const parent = el.parentNode;
  if (parent && parent.lastChild !== el) {
    parent.appendChild(el);
  }
  el.textContent = css || '';
}

/** Inject the global styles CSS into the editor canvas iframe for live preview. */
export function injectGlobalCss(editor, css) {
  try {
    const canvasDoc = editor?.Canvas?.getDocument?.();
    if (canvasDoc) upsertStyleEl(canvasDoc, CANVAS_STYLE_ID, css);
  } catch (e) {
    /* canvas may not be ready yet */
  }
}
